import React from "react";
import { format } from "date-fns";

const AddToCalendarButton = ({ ticket }) => {
    const handleAddToCalendar = () => {
        const { event, instance } = ticket;
        const startDate = new Date(instance.start);
        const endDate = new Date(instance.end);

        // Format to UTC format required for ICS
        const formatToICS = (date) => format(date, "yyyyMMdd'T'HHmmss'Z'");

        const icsContent = `
            BEGIN:VCALENDAR
            VERSION:2.0
            PRODID:-//Your App//EN
            BEGIN:VEVENT
            UID:${Date.now()}@yourapp.com
            DTSTAMP:${formatToICS(new Date())}
            DTSTART:${formatToICS(startDate)}
            DTEND:${formatToICS(endDate)}
            SUMMARY:${event.name}
            DESCRIPTION:Join us for ${event.name}!
            LOCATION:${event.attributes?.location || "TBA"}
            END:VEVENT
            END:VCALENDAR
        `.trim();

        const blob = new Blob([icsContent], { type: "text/calendar" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${event.name.replace(/\s+/g, "_")}.ics`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <button onClick={handleAddToCalendar} className="btn">
            Add to Calendar
        </button>
    );
};

export default AddToCalendarButton;